package com.steamstreet.vegasful.browser.public

import com.steamstreet.vegasful.browser.account.Account
import com.steamstreet.vegasful.browser.account.GraphQL
import com.steamstreet.vegasful.browser.account.subscriptions.onClick
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import com.steamstreet.vegasful.web.analytics.Analytics
import com.steamstreet.vegasful.web.analytics.SaveGesture
import com.steamstreet.vegasful.web.analytics.pageTypeOf
import kotlinx.browser.window
import org.w3c.dom.Element

/**
 * The add to calendar module.
 *
 * Adding to the calendar is the other gesture `event_saved` may mean — see [SaveGesture]. The
 * analytics event is sent for everyone; the CALENDAR interaction still needs a signed-in user to
 * belong to.
 */
fun addToCalendar(element: Element) {
    val eventId = element.getAttribute("data-event-id")
    val eventName = element.getAttribute("data-event-name")

    element.onClick {
        eventId?.let {
            Analytics.eventSaved(SaveGesture.CALENDAR, it, pageTypeOf(window.location.pathname))
        }

        if (Account.isLoggedIn()) {
            try {
                GraphQL.mutation {
                    subscriptions {
                        interact(InteractInput(InteractionType.CALENDAR, "events/${eventId}"))
                    }
                }
            } catch (t: Throwable) {
                GraphQL.logError("Failed to add event to calendar", t)
            }
        }
    }
}
